import { render } from "./normalisationdelafacture.vue?vue&type=template&id=2af6f08a&scoped=true"
import script from "./normalisationdelafacture.vue?vue&type=script&lang=js"
export * from "./normalisationdelafacture.vue?vue&type=script&lang=js"

import "./normalisationdelafacture.vue?vue&type=style&index=0&id=2af6f08a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af6f08a"]])

export default __exports__